/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Text from '../../../shared/components/Text/Text';

import iconSet from '../../../shared/images/teambuildr-selection.json';
import {
  deleteSavedCalendarItem,
  setDeleteStack,
} from '../ducks/calendarActions';

const ModalContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
`;

const IconCircle = styled('div')`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #F5F5F5;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;

const ModalText = styled('div')`
  margin-bottom: 15px;
  display: flex;
`;

const DeleteButton = styled('button')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  height: 48px;
  background: #DB3030;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 24px;
`;

const CloseButton = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  cursor: pointer;
`;

const ConfirmDeleteModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const deleteStack = useSelector((state) => state.calendar.data.deleteStack);
  const calendarItems = useSelector((state) => state.calendar.data.calendarItems);
  const dateToUse = modalData?.date || selectedDate;
  const formattedDate = moment(dateToUse).format('YYYY-MM-DD');
  const itemCount = modalData?.bulkDeleteAssignedIds?.length || 1;
  const itemText = itemCount === 1 ? 'workout item' : 'workout items';

  const handleDelete = () => {
    if (modalData) {
      // Get the actual content to add to the delete stack
      const content = calendarItems[formattedDate]?.exercises[modalData?.itemIndex];
      if (content) {
        /** Add to delete stack */
        const newDeleteStack = [...deleteStack];
        newDeleteStack.push(content);
        dispatch(setDeleteStack(newDeleteStack));
      }

      /** we need to pass the id as an array for the endpoint because it also accomodates a bulk
       * delete it needed
       */
      const assignedIds = modalData?.isBulkDelete ? modalData?.bulkDeleteAssignedIds : [modalData?.assignedId];
      /** Delete the item */
      dispatch(deleteSavedCalendarItem(
        currentUser.accountCode,
        assignedIds,
        modalData?.itemIndex,
        formattedDate,
        modalData?.isRecurring,
      ));
    }
    closeModal();
  };

  return (
    <ModalContainer>
      <CloseButton onClick={closeModal}>
        <IcomoonReact
          iconSet={iconSet}
          size={15}
          icon='remove'
          color='grey'
        />
      </CloseButton>

      <IconCircle>
        <IcomoonReact
          iconSet={iconSet}
          size={32}
          icon='trashcan'
          color='#DB3030'
        />
      </IconCircle>

      <ModalText>
        <Text fontSize='20px' fontWeight={600}>
          {`You are about to delete (${itemCount}) ${itemText}`}
        </Text>
      </ModalText>

      <DeleteButton onClick={handleDelete}>
        DELETE
      </DeleteButton>
    </ModalContainer>
  );
};

ConfirmDeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ConfirmDeleteModal;
